import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { basePathConfig } from "../../config";
import errorHandler from "../error/errorHandler";

// Thunks
// Fetch all location settings
export const fetchAllLocationSettings = createAsyncThunk(
  "locationSettings/fetch",
  async () => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.get(
          `${basePathConfig.baseURL}/app/sticky-location/account/${accountID}`,
          config
        );

        return await res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);

export const fetchLocationList = createAsyncThunk(
  "locationSettings/fetchLocationList",
  async () => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.get(
          `${basePathConfig.baseURL}/app/sticky-location/account/${accountID}`,
          config
        );

        return await res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);

// Add location settings
export const addLocationSettings = createAsyncThunk(
  "locationSettings/add",
  async (payloadData) => {
    try {
      console.log("addLocationSettings called with payload:", payloadData); // Debugging log

      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");
      const payload = {
        account_id: accountID,
        location_name: payloadData.location_name,
        description: payloadData.description,
        icon: payloadData.icon,
      };

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.post(
          `${basePathConfig.baseURL}/app/sticky-location/create`,
          payload,
          config
        );

        return await res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);

export const editLocationSettings = createAsyncThunk(
  "locationSettings/edit",
  async (payload) => {
    try {
      console.log(
        ` editLocationSettings  payload  = ${JSON.stringify(payload)}`
      );

      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!bearer_token || !accountID)
        return { message: "Unauthorized", status: 401 };

      const config = {
        headers: {
          Authorization: bearer_token,
        },
      };

      // Update the payload structure to match backend expectations
      const payloadData = {
        account_id: accountID,
        location_name: payload.location_name,
        description: payload.description,
        icon: payload.icon,
      };

      // Make sure we have a valid ID
      if (!payload._id) {
        throw new Error("Location ID is required");
      }

      const res = await axios.put(
        `${basePathConfig.baseURL}/app/sticky-location/${payload._id}`,
        payloadData,
        config
      );

      return await res.data;
    } catch (error) {
      return await errorHandler(error);
    }
  }
);

// Delete location settings
export const deleteLocationSettings = createAsyncThunk(
  "locationSettings/delete",
  async (payload) => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!bearer_token || !accountID)
        return { message: "Unauthorized", status: 401 };
      const payloadData = {
        isActive: payload.value,
      };

      const config = {
        headers: {
          Authorization: bearer_token,
        },
        data: payloadData,
      };
      console.log(
        ` deleteLocationSettings  payload  = ${JSON.stringify(payload)}`
      );

      console.log(
        ` editLocationSettings  payloadData  = ${JSON.stringify(payloadData)}`
      );
      const res = await axios.delete(
        `${basePathConfig.baseURL}/app/sticky-location/${payload._id}`,
        // data: payloadData,
        // headers: config.headers
        // payloadData,
        config
      );
      return await res.data;
    } catch (error) {
      return await errorHandler(error);
    }
  }
);

export const STATUSES = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
});

const initialState = {
  data: [],
  addData: [],
  editData: [],
  deleteData: [],
  status: STATUSES.SUCCESS,
  fetchLocationListData: {
    data: {},
    status: "",
    error: {},
  },
};

export const locationSettingsSlice = createSlice({
  name: "locationSettings",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLocationSettings.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchAllLocationSettings.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.SUCCESS;
      })
      .addCase(fetchAllLocationSettings.rejected, (state) => {
        state.status = STATUSES.ERROR;
      })
      .addCase(addLocationSettings.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(addLocationSettings.fulfilled, (state, action) => {
        state.addData = action.payload;
        state.status = STATUSES.SUCCESS;
      })
      .addCase(addLocationSettings.rejected, (state) => {
        state.status = STATUSES.ERROR;
      })
      .addCase(editLocationSettings.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(editLocationSettings.fulfilled, (state, action) => {
        console.log(
          `\n\n action.payload  == ${JSON.stringify(action.payload)}`
        );

        state.editData = action.payload;
        state.status = STATUSES.SUCCESS;
      })
      .addCase(editLocationSettings.rejected, (state) => {
        console.log(
          `\n\n STATUSES.ERROR  == ${JSON.stringify(STATUSES.ERROR)}`
        );
        state.status = STATUSES.ERROR;
        state.editData = [];
      })
      .addCase(deleteLocationSettings.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(deleteLocationSettings.fulfilled, (state, action) => {
        state.deleteData = action.payload;
        state.status = STATUSES.SUCCESS;
      })
      .addCase(deleteLocationSettings.rejected, (state) => {
        state.status = STATUSES.ERROR;
        state.deleteData = [];
      }) //  Location List
      .addCase(fetchLocationList.pending, (state) => {
        state.fetchLocationListData = {
          status: "loading",
          data: {},
          error: {},
        };
      })
      .addCase(fetchLocationList.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.fetchLocationListData = {
            status: "failed",
            data: {},
            error: action.payload.error,
          };
        } else {
          state.fetchLocationListData = {
            status: "succeeded",
            data: action.payload.data,
            error: {},
          };
        }
      })
      .addCase(fetchLocationList.rejected, (state, action) => {
        state.fetchLocationListData = {
          status: "failed",
          data: {},
          error: action.payload,
        };
      });
  },
});

export const { reset } = locationSettingsSlice.actions;
export default locationSettingsSlice.reducer;
